import { render, staticRenderFns } from "./ModalDeleteMedia.vue?vue&type=template&id=fbbb751c"
import script from "./ModalDeleteMedia.vue?vue&type=script&lang=js"
export * from "./ModalDeleteMedia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports